import { Component, OnInit,ViewChild } from '@angular/core';
import { FixedAssetService } from 'app/shared/services/fixed-asset.service';
import { Item } from 'app/shared/types/item';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';


@Component({
  selector: 'ngx-fixed-asset-list',
  templateUrl: './fixed-asset-list.component.html',
  styleUrls: ['./fixed-asset-list.component.scss']
})
export class FixedAssetListComponent implements OnInit {

  displayedColumns: string[] = ['AssetCode', 'AssetName', 'Category', 'Location','Qty','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  item : Item[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  
  statusCode: number;

  constructor(private fixedAssetService : FixedAssetService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private themeService: NbThemeService,
              private authService: AuthService,
              ) { }

  ngOnInit() {
    this.getAllItems();
    this.getControlPermissions();

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='FA'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  newButtonClick(){
   this.fixedAssetService.dataRow = null;
   this.router.navigate(['../fixed-asset'],{relativeTo : this.route});
   

  }
  
getAllItems(){
    this.fixedAssetService.getAll()
     .subscribe(
        (data) => {
                  this.item = data;
                  this.dataSource = new  MatTableDataSource (this.item );  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

     getRowData(row){   
      this.fixedAssetService.dataRow = row;  
      this.router.navigate(['../fixed-asset'],{relativeTo : this.route});
   }
        
   
   deleteButtonClick(id : string){
          this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
          .afterClosed().subscribe(res =>{
            if(res){
              this.fixedAssetService.deleteFixedAsset(id)
            .subscribe(
              (res) => {
                          this.toastr.success('Deleted successfully','Success');
                          this.getAllItems();
                          console.log(res);     
                        },        
              (err) =>  {
                          this.toastr.error('Failed to delete record','Failure');
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                )
            }
          });            
      }

      applyFilter(){
        this.dataSource.filter =this.searchKey.trim().toLowerCase();

      }
      onSearchClear(){
        this.searchKey = "";
        this.applyFilter();
      }



   

}